/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { AngularFireAction, DatabaseSnapshot } from '@angular/fire/compat/database';

import { LaborCount } from 'src/app/app-data/models/LaborCount';
import { FancyAction } from '../base/FancyAction';
import { FancyActionTypes } from '../base/FancyActionTypes';
import { FancyFirebaseList } from '../base/FancyFirebaseList';
import { AngularLandConnection, RefOrObservable } from '../base/interfaces';
import { DefaultActionHandlers } from '../generics/DefaultActionHandlers';
import { DefaultActionTypes } from '../generics/DefaultActionTypes';
import { logger } from '@touchplan/logging';

export class LaborCountList extends FancyFirebaseList<LaborCount, FancyAction> {
	private defaultActionsHandlers: DefaultActionHandlers<LaborCount, FancyAction, LaborCountList> =
		new DefaultActionHandlers(this, [DefaultActionTypes.addItem]);

	protected addActions = {
		[FancyActionTypes.childAdded]: FancyActionTypes.childAdded,
		[DefaultActionTypes.addItem]: DefaultActionTypes.addItem,
	};

	constructor(angularLand: AngularLandConnection, path: RefOrObservable, fancyJoins?: any) {
		//fix any's
		super(angularLand, path, FancyAction, fancyJoins);
	}

	public $$added(action: AngularFireAction<DatabaseSnapshot<any>>) {
		const labor = new LaborCount(action.key);
		labor.databaseUpdate(action.payload.val());
		return labor;
	}

	public $$updated(child: LaborCount, action: AngularFireAction<DatabaseSnapshot<any>>) {
		child.databaseUpdate(action.payload.val());
	}
	//
	// applyJoinData(baseKey: string, child: any) {
	// 	this.logger.log("APPLY JOIN", baseKey, child);
	// }
	//
	// getDataForKey(baseKey: string, child: any) {
	// 	this.logger.log("GET DATA", baseKey, child);
	// 	return child.view[baseKey]
	// }
	//
	// getPrevDataForKey(baseKey: string, child: any) {
	// 	this.logger.log("GET PREV DATA", baseKey, child);
	// }
}
